import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { CommonContext } from '../../../component/common/context/commonContext'
import { getContentSize } from '../../../utils/screenUtils'
import { useMountEffect } from 'primereact/hooks'
import { TakebackData, TakebackInboundSearch, TakebackInfoData, TakebackRecycleWait } from '../../../types/inbound'
import { isEmpty, size } from 'lodash'
import PdaTitle from '../../../component/common/PdaTitle'
import { InputText } from 'primereact/inputtext'
import { ScrollPanel } from 'primereact/scrollpanel'
import { classNames } from 'primereact/utils'
import TakebackInboundDialog from '../../../component/inbound/dialog/TakebackInboundDialog'
import TakebackInboundSelectDialog from '../../../component/inbound/dialog/TakebackInboundSelectDialog'
import TakebackRecycleDialog from '../../../component/inbound/dialog/TakebackRecycleDialog'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const TakebackInbound = () => {
    const { $http, $toast } = useContext(CommonContext)
    const { t } = useTranslation()
    const scanRef = useRef<HTMLInputElement>(null)
    const [lgstNo, setLgstNo] = useState<string>('')
    const [height, setHieght] = useState<number>(getContentSize())
    const [visibleTakebackDialog, setVisibleTakebackDialog] = useState<boolean>(false)
    const [visibleTakebackSelectDialog, setVisibleTakebackSelectDialog] = useState<boolean>(false)
    const [visibleRecycle, setVisibleRecycle] = useState<boolean>(false)
    const [recycleWait, setRecycleWait] = useState<TakebackRecycleWait[]>()
    const [recycle, setRecycle] = useState<TakebackRecycleWait>()
    const [takebackInfo, setTakebackInfo] = useState<TakebackInfoData>()
    const [takebacks, setTakebacks] = useState<TakebackData[]>([])
    const [params, setParams] = useState<TakebackInboundSearch>({
        lgstNo: '',
    })

    console.log(setHieght)

    useMountEffect(() => {
        findRecycle()

        setTimeout(() => {
            if (scanRef && scanRef.current) {
                scanRef.current.focus()
            }
        }, 300)
    })

    const findRecycle = async () => {
        const result = await $http().get(`/inbound/recycle`)
        setRecycleWait(result)
    }

    const openTakebackDialog = useCallback(
        async (takeback: TakebackData) => {
            const result = await $http().get(`/inbound/takeback-info/${takeback.tkbckUnitNo}/${takeback.seq}`)
            setLgstNo('')
            setTakebackInfo({ ...result, tkbckUnitNo: takeback.tkbckUnitNo, tkbckNo: takeback.tkbckNo, seq: takeback.seq })
            setVisibleTakebackDialog(true)
            setVisibleTakebackSelectDialog(false)
        },
        [$http],
    )

    const findTakeback = useCallback(
        async (params: TakebackInboundSearch) => {
            const result = await $http().get(`/inbound/takeback/${params.lgstNo}`)

            setLgstNo('')

            // 회수 물류코드가 없을때
            if (isEmpty(result)) {
                $toast({ title: t(tokens.common.fail), text: t(tokens.inbound.not_a_returned_inbound_item_label_barcode), icon: 'error' })
                if (scanRef && scanRef.current) {
                    scanRef.current.focus()
                }
                return
            }

            // 물류코드로 1개가 조회 되었을때
            if (size(result) === 1) {
                openTakebackDialog(result[0])
                if (scanRef && scanRef.current) {
                    scanRef.current.focus()
                }
            }
            // 물류코드로 1개 초과 조회 되었을때
            else {
                setTakebacks(result)
                setVisibleTakebackSelectDialog(true)
            }
        },
        [$http, $toast, openTakebackDialog],
    )

    useEffect(() => {
        if (params.lgstNo) {
            findTakeback(params)
        }
    }, [params, findTakeback])

    const onKeyDownSearch = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            setParams({
                ...params,
                lgstNo,
            })
        }
    }

    const getCardStyle = (scanYn: string) => {
        if (scanYn) {
            return {
                background: '#22C55E',
                border: '1px solid black',
            }
        } else {
            return {
                background: '#F59E0B',
                border: '1px solid black',
            }
        }
    }

    const onClickRecycle = (row: TakebackRecycleWait) => {
        if (row) {
            setRecycle(row)
            setVisibleRecycle(true)
        }
    }

    const onHideRecycle = (isAction: boolean) => {
        setVisibleRecycle(false)

        if (isAction) {
            findRecycle()
        }
    }

    return (
        <>
            <PdaTitle title={t(tokens.inbound.return_incoming)} historyBack goToHome />
            <div className="grid pda-search p-3 px-1 pb-2">
                <div className="col-12 flex">
                    <InputText
                        ref={scanRef}
                        value={lgstNo}
                        className="p-inputtext-md w-full"
                        placeholder={t(tokens.inbound.please_scan_return_incoming_label_barcode)}
                        onChange={(e) => setLgstNo(e.currentTarget.value)}
                        onKeyDown={(e) => onKeyDownSearch(e)}
                        inputMode="none"
                        autoFocus={true}
                    />
                </div>
            </div>
            <div className="grid pl-2">
                <div className="col-12 flex pl-2 pb-0">
                    <span className="rdms-text-primary font-bold">{t(tokens.inbound.items_for_conversion_to_good_condition)}</span>
                </div>
                {recycleWait && !isEmpty(recycleWait) ? (
                    <ScrollPanel className="flex w-full p-1" style={{ height: height }}>
                        {recycleWait.map((r) => (
                            <div className="mt-1" key={`${r.tkbckUnitNo}${r.seq}`} onClick={() => onClickRecycle(r)}>
                                <div className="card w-full p-1">
                                    <div className="col-12 flex py-0 font-bold text-lg">
                                        <div className={classNames('col-3 text-left w-full')}>{r.goodsNm}</div>
                                    </div>
                                    <div className="col-12 flex py-0 pt-0">
                                        <div className={classNames('col-3 text-left w-full pt-0')}>{r.specTxt}</div>
                                    </div>
                                    <div className="col-12 justify-content-between flex py-0 font-bold align-items-center text-sm">
                                        <div className={classNames('col-3 text-left w-full pt-0')}>
                                            <span className="font-bold rdms-text-deepblue">
                                                로케이션 :{' '}
                                                {`${r.areaNm} > ${r.sectorNm} > ${r.bayId} > ${r.rackRowId}${t(tokens.common.row)} ${r.rackColId}${t(
                                                    tokens.common.layer,
                                                )}`}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </ScrollPanel>
                ) : (
                    <div className="font-bold text-center w-full vertical-align-middle" style={{ paddingTop: height / 3 }}>
                        {t(tokens.inbound.please_scan_return_incoming_label_barcode)}
                    </div>
                )}
            </div>
            {visibleTakebackDialog && (
                <TakebackInboundDialog info={takebackInfo} visible={visibleTakebackDialog} onHide={() => setVisibleTakebackDialog(false)} />
            )}
            {visibleTakebackSelectDialog && (
                <TakebackInboundSelectDialog
                    info={takebacks}
                    visible={visibleTakebackSelectDialog}
                    onHide={() => setVisibleTakebackSelectDialog(false)}
                    selectedData={(data) => openTakebackDialog(data)}
                />
            )}
            {visibleRecycle && recycle && <TakebackRecycleDialog info={recycle} visible={visibleRecycle} onHide={onHideRecycle} />}
        </>
    )
}

export default TakebackInbound
